// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1KHGQ","inner":"Footer_inner__334r1"};